import _defineProperty from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import { jsxs, jsx } from 'react/jsx-runtime';
import { Button } from '@ariakit/react';
import { FolderShared } from '@box/blueprint-web-assets/icons/Content';
import { XMark, Folder } from '@box/blueprint-web-assets/icons/Fill';
import { Space6, Space4 } from '@box/blueprint-web-assets/tokens/tokens';
import clsx from 'clsx';
import { forwardRef, createRef } from 'react';
import { InlineError } from '../primitives/inline-error/inline-error.js';
import { useFullTextTooltip } from '../utils/useFullTextTooltip.js';
import { useUniqueId } from '../utils/useUniqueId.js';
import styles from './content-field.module.js';
import { messages } from './messages.js';

var ContentIconContainer = function ContentIconContainer(_ref) {
  var children = _ref.children;
  return jsx("div", {
    className: styles.contentIconContainer,
    children: children
  });
};

var ContentIcon = function ContentIcon(_ref2) {
  var isSharedFolder = _ref2.isSharedFolder,
      itemIcon = _ref2.itemIcon;

  if (itemIcon) {
    return itemIcon;
  }

  if (isSharedFolder) {
    return jsx(FolderShared, {
      "aria-label": messages.sharedFolderIconLabel,
      className: styles.contentIconShared,
      height: Space6,
      width: Space6
    });
  }

  return jsx(ContentIconContainer, {
    children: jsx(Folder, {
      "aria-label": messages.folderIconLabel,
      height: Space4,
      width: Space4
    })
  });
};

var handleOnClickClearButton = function handleOnClickClearButton(_ref3) {
  var ref = _ref3.ref,
      onClickClearButton = _ref3.onClickClearButton;
  return function (e) {
    var _ref$current;

    (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.focus();
    onClickClearButton(e);
  };
};

var contentFieldButtonTestId = 'ContentField-button';
var ContentField = /*#__PURE__*/forwardRef(function (_ref4, forwardedRef) {
  var _clsx, _clsx2;

  var clearButtonAriaLabel = _ref4.clearButtonAriaLabel,
      itemIcon = _ref4.itemIcon,
      hintText = _ref4.hintText,
      isSharedFolder = _ref4.isSharedFolder,
      onClick = _ref4.onClick,
      onClickClearButton = _ref4.onClickClearButton,
      title = _ref4.title,
      error = _ref4.error;
  var labelRef = /*#__PURE__*/createRef();

  var _useFullTextTooltip = useFullTextTooltip({
    ref: labelRef,
    textValue: title !== null && title !== void 0 ? title : hintText
  }),
      Tooltip = _useFullTextTooltip.Wrapper,
      wrapperProps = _useFullTextTooltip.wrapperProps;

  var inlineErrorId = useUniqueId('inline-error-');
  return jsxs("div", {
    className: styles.contentFieldWrapper,
    children: [jsxs("div", {
      className: styles.contentField,
      children: [jsx(Tooltip, _objectSpread(_objectSpread({}, wrapperProps), {}, {
        children: jsxs(Button, {
          ref: forwardedRef,
          "aria-describedby": inlineErrorId,
          className: clsx(styles.contentButton, (_clsx = {}, _defineProperty(_clsx, styles.hasSelection, title), _defineProperty(_clsx, styles.error, !!error), _clsx)),
          "data-testid": contentFieldButtonTestId,
          onClick: onClick,
          type: "button",
          children: [jsx(ContentIcon, {
            isSharedFolder: isSharedFolder,
            itemIcon: itemIcon
          }), jsx("div", {
            className: styles.contentLabelWrapper,
            children: jsx("div", {
              ref: labelRef,
              className: styles.contentLabel,
              children: title !== null && title !== void 0 ? title : hintText
            })
          })]
        })
      })), title && jsx(Button, {
        "aria-label": clearButtonAriaLabel !== null && clearButtonAriaLabel !== void 0 ? clearButtonAriaLabel : messages.clearContentFieldButtonLabel,
        className: clsx(styles.clearButton, (_clsx2 = {}, _defineProperty(_clsx2, styles.hasSelection, title), _defineProperty(_clsx2, styles.error, !!error), _clsx2)),
        onClick: handleOnClickClearButton({
          ref: labelRef,
          onClickClearButton: onClickClearButton
        }),
        type: "button",
        children: jsx(XMark, {
          "aria-label": messages.clearContentFieldIconLabel,
          height: Space6,
          width: Space6
        })
      })]
    }), jsx(InlineError, {
      className: styles.inlineError,
      id: inlineErrorId,
      children: error
    })]
  });
});
export { ContentField, contentFieldButtonTestId };